import type { SlotResourceInfo, TimeSlot } from './hooks/use-booking-reducer';

export function getAvailableStaff(timeSlots: TimeSlot[]) {
  const staff = new Map<string, Pick<SlotResourceInfo, 'id' | 'name'>>();

  for (const slot of timeSlots) {
    if (!slot.is_available) continue;

    for (const resource of slot.available_resources ?? []) {
      if (!staff.has(resource.id)) {
        staff.set(resource.id, { id: resource.id, name: resource.name });
      }
    }
  }

  return [...staff.values()];
}

export function filterTimeSlotsByStaff(timeSlots: TimeSlot[], staffId: string) {
  if (!staffId) return timeSlots;

  return timeSlots.filter(
    (slot) =>
      slot.is_available &&
      slot.available_resources?.some((resource) => resource.id === staffId),
  );
}
